import { defineComponent as _defineComponent } from 'vue'
import { isEmpty, isEmptyOrWhiteSpace } from "@/utils/Common";


export default /*#__PURE__*/_defineComponent({
  __name: 'SectionPanel',
  props: {
  title: { type: String, default: "" },
},
  setup(__props) {



return { __sfc: true,isEmpty, isEmptyOrWhiteSpace }
}

})